module.exports = __webpack_public_path__ + "media/application/images/demo/content_3-95a58c9b5d6099e83b78856c38c0c05e.jpg";